import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlConvenio = '/service/contabilidade/transparencia/convenio/'

class DetalhesRecursoConcedidoService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    consultarDetalhes(filtro) {
        let data = {
            sequencia: filtro.sequencia,
        }
        return this.conex.post(urlConvenio + 'convenioRecursoConcedido/', JSON.stringify(data))
    }

    consultarAditivos(filtro) {
        let data = {
            exercicio: filtro.exercicio,
            numero: filtro.numero,
        }
        return this.conex.post(urlConvenio + 'convenioAditivosRecursos/', JSON.stringify(data))
    }

    consultarPlanoTrabalho(filtro) {
        let data = {
            sequencia: filtro.sequencia,
        }
        return this.conex.post(urlConvenio + 'convenioPlanoTrabalho/', JSON.stringify(data))
    }

    consultarCronogramaDesembolso(filtro) {
        let data = {
            sequencia: filtro.sequencia,
        }
        return this.conex.post(urlConvenio + 'convenioCronogramaDesembolso/', JSON.stringify(data))
    }

    consultarControleInterno(filtro) {
        let data = {
            sequencia: filtro.sequencia,
        }
        return this.conex.post(urlConvenio + 'convenioControleInterno/', JSON.stringify(data))
    }

    consultarParecerGestor(filtro) {
        let data = {
            sequencia: filtro.sequencia,
        }
        return this.conex.post(urlConvenio + 'convenioParecerGestor/', JSON.stringify(data))
    }

    consultarParecerComissao(filtro) {
        let data = {
            sequencia: filtro.sequencia,
        }
        return this.conex.post(urlConvenio + 'convenioParecerComissao/', JSON.stringify(data))
    }

    consultarParecerAdministrador(filtro) {
        let data = {
            sequencia: filtro.sequencia,
        }
        return this.conex.post(urlConvenio + 'convenioParecerAdministrador/', JSON.stringify(data))
    }

    consultarResumoPrestacao(filtro) {
        let data = {
            sequencia: filtro.sequencia,
        }
        return this.conex.post(urlConvenio + 'convenioResumoPrestacao/', JSON.stringify(data))
    }

    consultarConvenentesConcedentes(filtro) {
        let data = {
            sequencia: filtro.sequencia,
        }
        return this.conex.post(urlConvenio + 'convenioConvenentesConcedentes/', JSON.stringify(data))
    }
}

export default DetalhesRecursoConcedidoService
